module.exports = __webpack_public_path__ + "img/linkedin-brands.31c41f4c.svg";